"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHideManuallySuppressed(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'm10.32 9.63 3.22-3.22c.34-.34.88-.33 1.21 0 .34.33.34.87 0 1.21l-1.81 1.81c-.21-.03-.42-.05-.63-.06-.09-.01-.18-.01-.32-.01h-.01c-.43 0-.86.05-1.27.15-.13.03-.26.07-.39.12Zm2.511-3.353-1.397-1.398.234-.234a.895.895 0 0 0 .01-1.265l-.01-.01-.056-.057a.894.894 0 0 0-1.265-.01l-.01.01-.235.234-1.285-1.285-4.005 4.015 1.276 1.285-5.825 5.825a.912.912 0 0 0 0 1.275l.056.056a.912.912 0 0 0 1.276 0l5.824-5.824 1.398 1.397 4.014-4.014ZM4.09 6.033l4.54-4.54a.85.85 0 0 0 .008-1.2L8.63.282a.85.85 0 0 0-1.2-.009l-.01.01-4.54 4.539a.856.856 0 0 0 1.21 1.21Zm5.26 8.427.56-.56c-.43-.25-.78-.61-1-1.05.22-.36.51-.68.84-.94.61-.48 1.36-.76 2.14-.79.04-.01.08-.01.12-.01.2-.01.4 0 .6.04l.64-.65a4.9 4.9 0 0 0-1.01-.13c-.07-.01-.15-.01-.23-.01-.36-.01-.72.04-1.06.13-.65.15-1.24.45-1.75.87-.15.12-.29.25-.42.39-.19.19-.35.4-.5.62-.11.15-.2.31-.28.48.31.64.78 1.19 1.35 1.61Zm5.36-3.21-.56.55c.4.27.74.63 1 1.05a3.733 3.733 0 0 1-3.1 1.75c-.22-.01-.44-.04-.65-.09l-.65.65c1.06.31 2.21.21 3.2-.26.9-.44 1.62-1.16 2.05-2.05-.31-.62-.75-1.17-1.29-1.6Zm-.26-1.54-5.59 5.58.71.71 5.58-5.59-.7-.7Z' })));
}
exports.default = SvgHideManuallySuppressed;
